import type { IntlShape } from "@formatjs/intl";
import { Button, Card, Descriptions, Empty, Flex, Table } from "antd";
import { EditOutlined } from "@ant-design/icons";
import type { Dispatch } from "@reduxjs/toolkit";
import { actions as routerActions } from "redux-router5";
import type { Materials, ServiceMaterials, Services } from "../generated-axios-client/index.ts";
import { PageTitleContainer } from "../../common/components/PageTitle.tsx";
import { routeNames } from "../common/routes.ts";

type ServiceViewRenderProps = {
  intl: IntlShape;
  service: Services;
  materialsList: Materials[];
  dispatch: Dispatch;
};

export const ServiceViewRender = ({
  intl,
  service,
  materialsList,
  dispatch,
}: ServiceViewRenderProps) => {
  const materialCatalog = Object.fromEntries(materialsList.map((m) => [m.id, m.name]));

  const suppliesColumns = [
    {
      key: "name",
      dataIndex: "material",
      title: intl.formatMessage({ id: "ticket_supplies_column_material" }),
      render: (id: string) => materialCatalog[id] ?? id,
    },
  ];

  return (
    <PageTitleContainer
      title={service.name}
      extra={
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={() =>
            dispatch(
              routerActions.navigateTo(routeNames.SETTINGS_SERVICE_EDIT, {
                id: service.id,
              })
            )
          }
        >
          {intl.formatMessage({ id: "service_edit_title" })}
        </Button>
      }
    >
      <Flex vertical gap="middle">
        <Card title={intl.formatMessage({ id: "service_section_details" })}>
          <Descriptions bordered column={2}>
            <Descriptions.Item label={intl.formatMessage({ id: "service_name" })}>
              {service.name}
            </Descriptions.Item>
            <Descriptions.Item label={intl.formatMessage({ id: "service_description" })}>
              {service.description}
            </Descriptions.Item>
          </Descriptions>
        </Card>
        <Card title={intl.formatMessage({ id: "service_section_supplies" })}>
          {service.materials && service.materials.length > 0 ? (
            <Table
              columns={suppliesColumns}
              dataSource={service.materials}
              rowKey={(r: ServiceMaterials) => r.id ?? r.material ?? ""}
              pagination={false}
              size="small"
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={intl.formatMessage({ id: "service_supplies_empty" })}
            />
          )}
        </Card>
      </Flex>
    </PageTitleContainer>
  );
};
